// extracted by mini-css-extract-plugin
export default {"head":"pages_head__0Xfqt","container":"pages_container__-MxLQ","sidenav":"pages_sidenav__DciHI","area":"pages_area__qIngo","nav":"pages_nav__WN7zV","main":"pages_main__9JAkZ"};